function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.74312C1 2.22814 2.22814 1 3.74312 1H10.2383C11.0391 1 11.7999 1.34992 12.3211 1.95792L14.3396 4.31288C14.7658 4.81005 15 5.44327 15 6.09808V12.2569C15 13.7719 13.7719 15 12.2569 15H3.74312C2.22814 15 1 13.7719 1 12.2569V3.74312Z",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3333 14V8.66667H4.66663V14",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66663 2V5.33333H9.99996",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-save",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2c76a9d3.svg";
export { ForwardRef as ReactComponent };